module.exports = __webpack_public_path__ + "front/img/b15.3627d11e.jpg";